import { connect } from 'stent/lib/helpers';
export const onStateChange = (machine, callback)=>{
    return connect().with(machine.name).map(function(m) {
        callback(m.state);
    });
};
